module.exports = __webpack_public_path__ + "static/media/logo.528eb878.png";